<template lang="pug">
    v-form.c-form(autocomplete="off")
        v-container(fluid grid-list-lg)
            v-layout.align-center(raw wrap)
                v-flex(xs12)

                    // Business information block title
                    title-component(
                        type="h4"
                        :title="$t('business.create.subtitleBusinessInformation')"
                    )

                v-flex(xs12 sm6)

                    // Business Name field
                    v-text-field(
                        :error-messages="errors.collect('businessName')"
                        :data-vv-as="$t('fields.businessName')"
                        :label="$t('fields.businessName')"
                        name="businessName"
                        v-model="model.name"
                        v-validate="'required|min:2|max:100'"
                        outline
                    )

                v-flex(xs12 sm6)

                    // Contact Email field
                    v-text-field(
                        :error-messages="errors.collect('contactEmail')"
                        :data-vv-as="$t('fields.contactEmail')"
                        :label="$t('fields.contactEmail')"
                        name="contactEmail"
                        type="email"
                        v-model.lazy="model.owner.email"
                        v-validate="'required|email'"
                        outline
                    )

                v-flex(xs12 sm6)

                    // Сontact Name field
                    v-text-field(
                        :error-messages="errors.collect('contactName')"
                        :data-vv-as="$t('fields.contactName')"
                        :label="$t('fields.contactName')"
                        name="contactName"
                        v-model.lazy="model.owner.fullName"
                        v-validate="'required|min:2|max:72'"
                        outline
                    )

                v-flex(xs12 sm6)

                    // Contact Phone field
                    v-text-field(
                        :error-messages="errors.collect('phone')"
                        :data-vv-as="$t('fields.phone')"
                        :label="$t('fields.phone')"
                        name="phone"
                        v-model.lazy="model.owner.phone"
                        v-validate="'required|min:6'"
                        mask="###-###-######-####"
                        outline
                    )


                v-flex(xs12 sm6)

                    // Max Capacity field
                    v-text-field(
                        :error-messages="errors.collect('maxUsers')"
                        :data-vv-as="$t('fields.maxUsers')"
                        :label="$t('fields.maxUsers')"
                        name="maxUsers"
                        v-model.lazy="model.maxUsers"
                        v-validate="'required|numeric|min_value:1|max_value:15000'"
                        outline
                    )

                v-flex(xs12 sm6)

                    // Max Capacity field
                    v-text-field(
                        :error-messages="errors.collect('domain')"
                        :data-vv-as="$t('fields.domain')"
                        :label="$t('fields.domain')"
                        name="domain"
                        v-model.lazy="model.domain"
                        v-validate="'required|min:2|max:512'"
                        outline
                    )

                v-flex(xs12 sm6)

                    // Participate in Challenge
                    v-checkbox.mt-0(
                        v-model="model.isChallenge"
                        :label="$t('fields.challenge')"
                    )
</template>

<script>
    import Title from '~components/Title';
    import { mapFields } from 'vuex-map-fields';
    import { mapActions } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            TitleComponent: Title
        },
        computed: {
            ...mapFields('businesses', {
                model: 'business'
            })
        },
        methods: {
            ...mapActions('businesses', ['create']),

            /**
             * Create Business account on submit
             * @returns {boolean}
             */
            async submit() {
                // Validate all fields and check in no errors
                const validation = await this.$validator.validateAll();
                if (!validation) return;

                // Call store action Create Business account
                this.create();
            }
        }
    };
</script>
